let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d1cQg")).then(() => parcelRequire('lfC1W'));